module.exports = __webpack_public_path__ + "static/media/Group 22.cd971591.svg";